module.exports = __webpack_public_path__ + "static/img/template_img.83662e05.jpg";